export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);

export const endpoints = {
  status: '/status/',
  questions: '/questions/',
  answersConfirmation: '/answers/',
  answersUploadRejected: '/answers/upload-rejected',
  interviewPreview: '/interview-preview/',
  interactions: '/interview-interactions/',
  qrApplyJob: '/qr-apply/:property_id',
};

export const routes = {
  root: '/',
  apply: '/qr-apply/:property_id',
  applyForm: '/qr-apply/:property_id/form',
  welcome: '/welcome',
  tutorial: '/tutorial',
  questions: '/questions',
  answers: '/answers',
  finish: `/finish`,
  interviewPreview: '/interview-preview',
  offerConfirmation: '/offer-confirmation',
  interactionsConfirmation: '/interactions-confirmation',
};

export const DEBUG = 'debug';
export const testInvitationKey = 'AAC25A';
